import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CtaAction } from '@sc/data-access-models';
import { AuthOktaService, AUTH_OKTA_MODULE_CONFIG } from '../services';

export function AuthenticationGuard(): CanActivateFn {
  const authOktaConfig = inject(AUTH_OKTA_MODULE_CONFIG);
  const authOktaService = inject(AuthOktaService);
  const router = inject(Router);
  const redirectUrl = authOktaConfig.guardRedirectUrl;

  return async () => {
    if (!(await authOktaService.checkIsAuthenticated())) {
      authOktaService.setHoldAction(
        `${window.location.pathname}${window.location.search}` as CtaAction
      );
      return router.parseUrl(redirectUrl);
    }
    return true;
  };
}
